"use client";

import { AuthButton } from "@/components/auth-button";
import { useAuth } from "@/components/auth-provider";
import { PriceText } from "@/components/price-text";
import { useOfferCountdown } from "@/hooks/use-offer-countdown";
import { useStartingPrice } from "@/hooks/use-starting-price";
import { piEvents } from "@/lib/analytics";
import {
  PI_CTA_LOCATION,
  PI_CTA_NAME,
  PI_DESTINATION,
  PI_LOGIN_ENTRY_POINT,
} from "@/lib/analytics/schema";
import { DEFAULT_ORIGINAL_PRICE, FINAL_CTA_COPY, PRICING_COPY } from "@/lib/site-copy";

export function FinalCtaSection() {
  const startingPrice = useStartingPrice();
  const countdown = useOfferCountdown();
  const { isSignedIn } = useAuth();

  return (
    <section className="bg-pi-accent-deep">
      <div className="mx-auto max-w-[760px] px-4 py-14 text-center sm:px-6 lg:px-8 lg:py-[88px]">
        <h2 className="m-0 text-[clamp(24px,3.6vw,34px)] font-bold leading-snug text-pi-bright">
          {startingPrice?.originalPrice ?? DEFAULT_ORIGINAL_PRICE}{" "}
          {FINAL_CTA_COPY.notPrefix}{" "}
          <PriceText value={startingPrice?.full} className="min-w-[8ch]" />.
        </h2>
        <p className="mt-3.5 mb-2 text-[clamp(15px,1.6vw,18px)] text-pi-text">
          {FINAL_CTA_COPY.subheadline}
        </p>
        <p className="mt-0 mb-6 text-sm font-bold text-pi-gold">
          {PRICING_COPY.offerEndsPrefix}{" "}
          <PriceText value={countdown.clock} className="min-w-[6ch] tabular-nums" />
        </p>
        <AuthButton
          size="large"
          variant="gold"
          className="animate-[pulse-gold_2.4s_ease-in-out_infinite] break-words"
          loginEntryPoint={PI_LOGIN_ENTRY_POINT.FINAL_CTA_START_LEARNING}
          trackClick={() =>
            piEvents.ctaClicked({
              ctaName: PI_CTA_NAME.START_LEARNING_FREE,
              ctaLocation: PI_CTA_LOCATION.FINAL_SECTION,
              destination: isSignedIn
                ? PI_DESTINATION.PW_HOME
                : PI_DESTINATION.LOGIN_MODAL,
            })
          }
        >
          <PriceText value={startingPrice?.full} className="min-w-[8ch]" />{" "}
          {FINAL_CTA_COPY.ctaSuffix} →
        </AuthButton>
        <p className="mt-[18px] mb-0 text-[13px] text-[#B9AECF]">
          {FINAL_CTA_COPY.trustLine}
        </p>
      </div>
    </section>
  );
}
